module.exports = __webpack_public_path__ + "static/media/tripadvisor-dark.047ce6c3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/style/images/tripadvisor-dark.svg
// module id = 436
// module chunks = 0